import React, { useEffect, useMemo, useState } from "react";

import { API, graphqlOperation } from "aws-amplify";
import { assetTypeByActiveByName } from "../../../../graphql/queries";

import { Grid } from "@material-ui/core";
import {
  Button,
  Datagrid,
  Labeled,
  SelectField,
  TextField,
  useNotify,
} from "react-admin";

import { AddIcon, EditIcon } from "../../../../components/common/iconography";
import { SortedArrayField } from "../../../../components/common/SortedArrayField";
import { deepRedirect } from "../../../../utils/utils";
import { logError } from "../../../../utils/appUtils";

const fetchAssetTypes = async (record, setAssetTypes, notify) => {
  try {
    const response = await API.graphql(
      graphqlOperation(assetTypeByActiveByName, {
        reloadYardId: record.id,
        activeName: { beginsWith: { active: "true" } },
      })
    );

    setAssetTypes(response.data.assetTypeByActiveByName);
  } catch (error) {
    logError("reloadYard:AssetTypePanel:fetchAssetTypes", error, notify);
  }
};

const handleEdit = ({ record, history, backPath }) => {
  deepRedirect(history, `/assetTypes/${record.id}`, backPath);
};

const AssetTypePanel = (props) => {
  const { record, disabled } = props;
  const notify = useNotify();
  const [assetTypes, setAssetTypes] = useState([]);
  const areas = useMemo(
    () => record?.areas?.items?.filter((itm) => itm.active === "true") || [],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    fetchAssetTypes(record, setAssetTypes, notify);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record]);

  if (disabled)
    return <AssetTypeShow {...props} assetTypes={assetTypes} areas={areas} />;
  return <AssetTypeList {...props} areas={areas} assetTypes={assetTypes} />;
};

const AssetTypeList = (props) => {
  const { assetTypes, areas, history } = props;
  const backPath = [history.location.pathname + history.location.search];

  const handleCreate = () => {
    deepRedirect(history, `/assetTypes/create`, backPath);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Labeled label="Asset Types" fullWidth>
          <SortedArrayField
            {...props}
            record={assetTypes}
            source="items"
            sort={{ field: "name", order: "ASC" }}
          >
            <Datagrid
              bulkActionButtons={false}
              rowClick={(jsonRecord, basePath, record) =>
                handleEdit({ ...props, record, backPath })
              }
            >
              <TextField source="name" />
              <TextField source="maxConcurrentBookings" label="Max. Bookings" />
              <SelectField source="areaId" label="Area" choices={areas} />
              <EditButton {...props} />
            </Datagrid>
          </SortedArrayField>
        </Labeled>
      </Grid>
      <Grid item xs={12}>
        <Button label="Add" color="default" onClick={handleCreate}>
          <AddIcon />
        </Button>
      </Grid>
    </Grid>
  );
};

const EditButton = (props) => {
  return (
    <Button
      label="Edit"
      size="small"
      color="primary"
      // onClick= rowClick handles redirect
    >
      <EditIcon />
    </Button>
  );
};

const AssetTypeShow = (props) => {
  const { assetTypes, areas } = props;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Labeled label="Asset Types" fullWidth>
          <SortedArrayField
            {...props}
            record={assetTypes}
            source="items"
            sort={{ field: "name", order: "ASC" }}
          >
            <Datagrid>
              <TextField source="name" />
              <TextField source="maxConcurrentBookings" label="Max. Bookings" />
              <SelectField source="areaId" label="Area" choices={areas} />
            </Datagrid>
          </SortedArrayField>
        </Labeled>
      </Grid>
    </Grid>
  );
};

export default AssetTypePanel;
